import { ACCOUNT_ACCESS_TYPE } from '@/store/constants'

const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  realName: (state) => state.user.realName,
  unionCode: (state) => state.user.unionCode,
  userId: (state) => state.user.userId,
  userCode: (state) => state.user.userCode,
  telNumber: (state) => state.user.telNumber,
  companyCode: (state) => state.user.companyCode,
  companyName: (state) => state.user.companyName,
  userInfo: (state) => state.user.userInfo,
  departmentName: (state) => state.user.departmentName,
  businessCode: (state) => state.user.businessCode,
  permission_routes: (state) => state.permission.permissionRoutes,
  permissionCodes: (state) => state.permission.permissionCodes,
  pathIndex: (state) => state.permission.pathIndex,
  pathTitle: (state) => state.permission.pathTitle,
  titlePath: (state) => state.permission.titlePath,
  pathCacheList: (state) => state.permission.pathCacheList,
  routesMap: (state) => state.permission.routesMap,
  sidebarObj: (state) => state.permission.sidebarObj,
  showLoading: (state) => state.app.showLoading,
  isCurrentVersion: (state) => state.version.isCurrentVersion,
  versionDay: (state) => state.version.versionDay,
  auditStatus: (state) => state.user.auditStatus,
  /** 当前用户的角色 */
  role: (state) => state.user.role, // 根据role.roleCode  a_admin：A端后台  pharmacy_admin：云药房后台-商户  pharmacy_store：云药房后台-店铺
  enableAddAccount: (state) =>
    state.user.accountAccessType !== ACCOUNT_ACCESS_TYPE.OA,
  waterMarkStr: (state) => state.user.waterMarkStr, // 图片水印
  currentDrugCode: (state) => state.drug.currentDrugCode
}
export default getters
